import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import CircularProgress from "@mui/material/CircularProgress";

import COLOR_THEMES from "../../colorThemes";
import LoadingBar from '../../lib/react-redux-loading-bar';

const MaterialSpinner = (props) => {
  const {activeTheme, color, size, withCounter} = props;

  const style = {'color': color || COLOR_THEMES[activeTheme].active}

  if (size) { // in order not to break others with size auto
    return (
      <div className="loader">
        <CircularProgress style={style} size={size}/>
      </div>
    )
  }

  return (
    <div className="loader" style={withCounter ? style : null}>
      {withCounter ? <LoadingBar className="loader-counter"/> : null}
      <CircularProgress style={style}/>
    </div>
  )
};

MaterialSpinner.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  withCounter: PropTypes.bool,
}

const mapStateToProps = (store) => {
  return {
    activeTheme: store.serverState.activeTheme,
  };
};

export default connect(mapStateToProps)(MaterialSpinner)
